import {Component} from '@angular/core';

@Component({
  selector: 'app-placeholder',
  template: `<router-outlet></router-outlet>`,
})
export class PlaceholderComponent {}
